import { UserBodyInputComponent, UserBodySelectionInputInfoModel } from '../utils/types';

export const mapSelectionListToComponent = (
  item: UserBodySelectionInputInfoModel,
  value: number | null,
): UserBodyInputComponent => {
  return {
    type: 'SELECTION',
    position: 0,
    key: item.key,
    label: item.label,
    min: item.min,
    max: item.max,
    gap: item.gap,
    anchor: item.anchor,
    placeholder: item.placeholder,
    selected_value: value ?? item.selectedValue,
    measure_unit: item.measureUnit,
    group: {
      key: 'fashion', // TODO: 서버에서 내려주는 값이 없어서 임시 고정
      label: '체형정보',
      __typename: 'UxUserBodyInputGroup',
    },
    __typename: 'UxUserBodySelectionInputInfo',
  };
};

